var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAttachment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "#f4f4f4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4895 19.1821L18.2675 11.4041C19.2435 10.4281 20.6495 10.2511 21.6265 11.2271C22.6025 12.2031 22.4265 13.6101 21.4495 14.5861L13.3175 22.7181C11.9035 24.1321 9.07454 24.1321 7.30754 22.3641C5.53954 20.5961 5.53954 17.7681 6.95354 16.3541L15.0855 8.22211C16.3083 7.02163 17.9556 6.35255 19.6692 6.36042C21.3827 6.36829 23.0238 7.05249 24.2355 8.26416C25.4472 9.47583 26.1314 11.1169 26.1392 12.8305C26.1471 14.544 25.478 16.1914 24.2775 17.4141L19.6815 22.0101",
    stroke: "#929292",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttachment);
export default __webpack_public_path__ + "static/media/attachment.10df117bf178c73f0e9da0df6e6f92a3.svg";
export { ForwardRef as ReactComponent };